import {
  Edit,
  SimpleForm,
  NumberInput,
  TextInput,
  DateInput,
  required,
  minValue,
} from "react-admin";
import type { EditProps } from "react-admin";

export const ProjectInayatEdit = (props: EditProps) => (
  <Edit
    {...props}
    transform={(data: Record<string, unknown>) => ({
      amount: Number(data.amount),
      receivedDate: data.receivedDate,
      reference:
        typeof data.reference === "string" ? data.reference.trim() || undefined : data.reference,
      remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
    })}
  >
    <SimpleForm>
      <NumberInput source="amount" validate={[required(), minValue(1)]} />
      <DateInput source="receivedDate" validate={required()} />
      <TextInput source="reference" fullWidth />
      <TextInput source="remarks" multiline fullWidth />
    </SimpleForm>
  </Edit>
);
